import { DialogTitle, Icon } from '@mui/material';
import React from 'react';
import { CButton } from '../StyledComponent';

function CDialogHeader({ title = "", disabled = false, onClose = () => { } }) {
    const containerStyle = { padding: "0.5rem 1rem" }
    return (
        <DialogTitle sx={{
            display: 'flex', justifyContent: 'space-between',
            alignItems: 'center', columnGap: '0.5rem', ...containerStyle
        }}>
            <label style={{ textTransform: 'capitalize' }}>{title}</label>
            <CButton onClick={onClose} variant='text' padding={0} sx={{ minWidth: 0 }} disabled={disabled} >
                <Icon>close</Icon>
            </CButton>
        </DialogTitle>
    );
}

export default CDialogHeader;